import { createSlice } from '@reduxjs/toolkit';
import { changeGlobalParameter } from 'shared/product_tabs/tab_project/actions/changeGlobalParameter';
import { validator } from 'shared/product_tabs/tab_stencils/slice/validator';
import { changeParametersForStencil } from 'shared/product_tabs/tab_stencils/slice/utils/changeParameter';
import { updateStencilsForOrder } from 'shared/product_tabs/tab_stencils/slice/utils/updateStencilsForOrder';
import { addStencils } from 'shared/product_tabs/tab_stencils/slice/utils/addStencils';
import { deleteStencilsFromCart } from 'shared/product_tabs/tab_stencils/slice/utils/deleteStencilsFromCart';
import { preserveStencilsParameters } from 'shared/product_tabs/tab_stencils/slice/utils/preserveStencilsParameters';
import initialState from 'shared/product_tabs/tab_stencils/data/initialState';

const stencilsSlice = createSlice({
  name: 'stencils',
  initialState,
  reducers: {
    changeParameter: (state, action) => {
      const { name, value, ref } = action.payload;
      changeParametersForStencil(state, name, value, ref);
      updateStencilsForOrder(state);
    },
    changeStencilsParameter: (state, action) => {
      const { name, value } = action.payload;
      state.stencilsParameters[name] = value;
      updateStencilsForOrder(state);
    },
    changeStencilsType(state, action) {
      state.stencilsType = action.payload;
      validator.purgeFields();
      deleteStencilsFromCart(state);
      addStencils(state);
    },
    changeStencilsSide(state, action) {
      const prevStencilSide = state.stencilsSide;
      const prevStencils = _.cloneDeep(state.stencils);
      deleteStencilsFromCart(state);

      state.stencilsSide = action.payload;
      addStencils(state);
      preserveStencilsParameters(state, prevStencilSide, prevStencils);
      updateStencilsForOrder(state);
    },
    deleteStencil(state) {
      deleteStencilsFromCart(state, true);
    },
    updateValidatorFlag(state) {
      state.validatorFlag = !state.validatorFlag;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(changeGlobalParameter, (state, action) => {
        const { name, value } = action.payload;
        if (!['part_number', 'revision'].includes(name)) return;

        state.stencilsParameters[name] = value;
      });
  },
});

export const {
  changeParameter,
  changeStencilsType,
  changeStencilsSide,
  changeStencilsParameter,
  deleteStencil,
  updateValidatorFlag,
} = stencilsSlice.actions;

export default stencilsSlice.reducer;

export const destroy = (list) => (dispatch, getState) => {
  const { stencilsToDestroy } = getState().smtStencil;

  if (stencilsToDestroy && stencilsToDestroy.length) {
    return list.concat(stencilsToDestroy);
  }

  return list;
};
